import React, { FC } from 'react';

import { Grid } from '@chakra-ui/react';

import { MetadataCommonFields } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/Components/MetadataCommonFields';
import { useActiveResourceContext } from 'containers/ActiveCloudResource/hooks/context/context';

import {
  BedrockAgentActionGroupExecutorLambdaARNs,
  BedrockAgentActionGroupNames,
  BedrockAgentActionGroupStates,
  BedrockAgentAliasNames,
  BedrockAgentFoundationModel,
  BedrockAgentGuardrailIdentifier,
  BedrockAgentGuardrailVersion,
  BedrockAgentIAMRoleARN,
  BedrockAgentKMSKeyARN,
  BedrockAgentKnowledgeBases,
  UpdatedAt,
} from '../../../../Components/MetadataField/MetaGridFields';

export const AWSBedrockAgentMetadata: FC = () => {
  const { resourceDetails, resourceInsight } = useActiveResourceContext();
  const { data: resource } = resourceDetails;
  const { data: insight } = resourceInsight;
  const metadata = { ...resource, ...insight };

  return (
    <Grid templateColumns="repeat(4, 1fr)" gap={4}>
      <MetadataCommonFields
        state={metadata}
        availabilityZone="None"
        vpc="None"
        owner="None"
        createdAt={metadata}
      />
      {UpdatedAt(metadata)}
      {BedrockAgentFoundationModel(metadata)}
      {BedrockAgentGuardrailIdentifier(metadata)}
      {BedrockAgentGuardrailVersion(metadata)}
      {BedrockAgentKnowledgeBases(metadata)}
      {BedrockAgentActionGroupNames(metadata)}
      {BedrockAgentActionGroupStates(metadata)}
      {BedrockAgentActionGroupExecutorLambdaARNs(metadata)}
      {BedrockAgentAliasNames(metadata)}
      {BedrockAgentIAMRoleARN(metadata)}
      {BedrockAgentKMSKeyARN(metadata)}
    </Grid>
  );
};
